var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.gameState === 'menu')?_c('Menu'):_vm._e(),(_vm.gameState !== 'menu')?_c('Game'):_vm._e(),(_vm.gameState === 'setup')?_c('Settings'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }